const modules = {};
const storeFiles = require.context('.', true, /\.js$/);
storeFiles.keys().forEach((fileName) => {
  if (fileName !== './index.js') {
    const store = require(`${fileName}`);
    const modleName = fileName.slice(2).split('/')[0];
    modules[modleName] = store.default;
  }
});
export default modules;
